import React, { useState, useEffect } from "react";
import { api, API_ENDPOINTS } from "../../config/api";

export default function WishlistPage() {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    async function fetchWishlist() {
      setLoading(true);
      setError("");
      try {
        const data = await api.get(API_ENDPOINTS.CUSTOMER_WISHLIST(userId));
        setWishlist(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    if (userId) fetchWishlist();
  }, [userId]);

  async function remove(item) {
    try {
      await apiRequestDeleteWithBody(API_ENDPOINTS.CUSTOMER_REMOVE_FROM_WISHLIST(userId), item);
      setWishlist(prev => prev.filter(f => f !== item));
    } catch (err) {
      setError("Failed to remove item");
    }
  }

  function orderNow(item) {
    alert(`Order now: ${item.name}`);
  }

  if (loading) return <div className="p-10 text-center">Loading...</div>;
  if (error) return <div className="p-10 text-center text-red-600">{error}</div>;

  return (
    <div className="app-page-narrow surface-panel">
      <h2 className="text-2xl font-bold mb-6 text-[#16213e]">Wishlist / Favorites</h2>
      {wishlist.length === 0 ? (
        <div className="text-gray-500">Your wishlist is empty.</div>
      ) : (
        <ul className="space-y-5">
          {wishlist.map((item, idx) => (
            <li key={idx} className="flex items-center gap-4 bg-gray-50 rounded-xl p-4 border border-gray-100">
              {item.type === "restaurant" ? (
                <div className="w-14 h-14 rounded-xl border border-gray-200 bg-orange-100 flex items-center justify-center">
                  {item.img ? (
                    <img
                      src={item.img}
                      alt={item.name}
                      className="w-full h-full rounded-xl object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div className="flex items-center justify-center text-orange-600 font-bold text-lg" style={{ display: item.img ? 'none' : 'flex' }}>
                    🍽️
                  </div>
                </div>
              ) : (
                <span className="w-14 h-14 flex items-center justify-center rounded-xl bg-orange-100 text-orange-600 font-bold text-xl border border-gray-200">🍽️</span>
              )}
              <div className="flex-1">
                <div className="font-semibold text-[#16213e]">{item.name}</div>
                {item.type === "dish" && <div className="text-xs text-gray-500">from {item.restaurant}</div>}
              </div>
              <button className="bg-orange-500 text-white px-5 py-2 rounded-xl font-bold shadow hover:bg-orange-600 transition text-xs" onClick={() => orderNow(item)}>Order Now</button>
              <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-xl font-bold shadow hover:bg-gray-300 transition text-xs" onClick={() => remove(item)}>Remove</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

async function apiRequestDeleteWithBody(endpoint, data) {
  return api.delete(endpoint, data);
}
